import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { TomoDetails } from './components/TomoDetails';
import { Bonuses } from './components/Bonuses';
import { CountdownPricing } from './components/CountdownPricing';
import { KitScale } from './components/KitScale';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-brand-dark font-sans text-slate-200 selection:bg-brand-accent selection:text-brand-dark" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <PainPoints data-id="element-5" />
        <ProductOverview data-id="element-6" />
        <TomoDetails data-id="element-7" />
        <Bonuses data-id="element-8" />
        <CountdownPricing data-id="element-9" />
        <KitScale data-id="element-10" />
        <MoreTestimonials data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <CostComparison data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
    </div>;
}